import React from "react";
import Journey from "./Journey";

const steps = [
    {
        target: '[data-tour="project-dashboard"]',
        title: "Dashboard",
        content: "Open the Dashboard to monitor project activity, performance, conversations, and usage metrics.",
        route: "sidebar",
        roles: ["ADMIN", "MANAGER", "AGENT"],
        placement: "right",
        skipBeacon: true,
    },
    {
        target: '[data-tour="project-supervision"]',
        title: "Supervision",
        content: "Use Supervision to follow live conversations and assist when an agent needs help.",
        route: "sidebar",
        roles: ["ADMIN", "MANAGER", "AGENT"],
        placement: "right",
        skipBeacon: true,
    },
    {
        target: '[data-tour="project-designer"]',
        title: "Designer",
        content: "Build and maintain the assistant’s conversation flows in the Designer.",
        route: "sidebar",
        roles: ["ADMIN", "MANAGER"],
        placement: "right",
        skipBeacon: true,
    },
    {
        target: '[data-tour="project-message-annotation"]',
        title: "Message Annotation",
        content: "Review and annotate messages to improve conversation quality and training data.",
        route: "sidebar",
        roles: ["ADMIN", "MANAGER", "ANNOTATOR"],
        placement: "right",
        skipBeacon: true,
    },
    {
        target: '[data-tour="project-mcp-registry"]',
        title: "MCP Registry",
        content: "Manage the external MCP services and tools available to this project.",
        registryTarget: '[data-tour="project-connectors"]',
        registryTitle: "Connectors",
        registryContent: "Connect mail, Viber and WhatsApp, and manage the external MCP services and tools available to this project.",
        route: "sidebar",
        roles: ["ADMIN", "MANAGER"],
        placement: "right",
        skipBeacon: true,
    },
    {
        target: '[data-tour="project-knowledge-manager"]',
        title: "Knowledge Manager",
        content: "Manage the project’s knowledge sources, topics, and related content.",
        route: "sidebar",
        roles: ["ADMIN", "MANAGER"],
        placement: "right",
        skipBeacon: true,
    },
    {
        target: '[data-tour="project-settings"]',
        title: "Settings",
        content: "Open the Settings menu for project details, voice configuration, vocabulary, and telephony options.",        route: "sidebar",
        roles: ["ADMIN", "MANAGER"],
        placement: "right",
        skipBeacon: true,
    },
    {
        target: '[data-tour="dashboard-filters"]',
        title: "Choose the time range",
        registryTitle: "Filter the dashboard",
        content: "Change the reporting period or configure automatic refresh for the dashboard data.",
        registryContent: "Pick a language and the Production or Stage version, and set how often the dashboard refreshes.",
        route: "dashboard",
        roles: ["ADMIN", "MANAGER", "AGENT"],
        placement: "bottom-end",
        skipBeacon: true,
    },
    {
        target: '[data-tour="conversations-table"]',
        title: "Review conversations",
        content: "Use the conversation area to inspect recent activity and open individual conversations for more detail.",
        route: "dashboard",
        roles: ["ADMIN", "MANAGER", "AGENT"],
        placement: "top-start",
        skipBeacon: true,
    },
    {
        target: '[data-tour="conversations-status"]',
        title: "Conversation status",
        content: "Track conversation outcomes and usage signals here, including status totals and tag activity.",
        registryContent: "Track how conversations ended here, with a total for each outcome.",
        route: "dashboard",
        roles: ["ADMIN", "MANAGER", "AGENT"],
        placement: "top-start",
        skipBeacon: true,
    },
    {
        target: '[data-tour="flow-canvas"]',
        title: "Build your flow",
        content: "Arrange nodes on the canvas and connect them to define how the assistant responds.",
        route: "flow",
        roles: ["ADMIN", "MANAGER"],
        placement: "top",
        skipBeacon: true,
    },
    {
        target: '[data-tour="flow-search"]',
        title: "Find nodes quickly",
        content: "Search the current flow when it becomes too large to navigate manually.",
        route: "flow",
        roles: ["ADMIN", "MANAGER"],
        placement: "bottom",
        skipBeacon: true,
    },
];

// registry: journey of a registry project; its dashboard is `dashboardPath` (the sub project's base path) and the
// steps use the registry wording (registryTitle / registryContent)
export const ProjectJourney = ({run = false, pathname = "", userRole, runId = 0, onFinish, registry = false, dashboardPath}) => {
    // Designer has its own journey; only the project root includes Dashboard steps.
    const onDashboard = registry
        ? pathname.replace(/\/$/, "") === dashboardPath
        : /^\/project\/[^/]+\/?$/.test(pathname);
    const currentRoute = onDashboard ? "dashboard" : "sidebar";
    const currentSteps = steps.filter((step) => (
        step.roles.includes(userRole) && (step.route === "sidebar" || step.route === currentRoute)
    )).map((step) => registry
        ? {
            ...step,
            target: step.registryTarget ?? step.target,
            title: step.registryTitle ?? step.title,
            content: step.registryContent ?? step.content,
        }
        : step);

    return (
        <Journey
            key={`${run}-${currentRoute}-${userRole}-${runId}`}
            steps={currentSteps}
            run={run && !!userRole && currentSteps.length > 0}
            onFinish={onFinish}
        />
    );
};

export default ProjectJourney;
